import React, { PureComponent } from 'react'
import { Image, ImageStyle, type StyleProp, StyleSheet } from 'react-native'
import { ImageRatios, ImageRatioStyle } from '@adalo/constants'

import { applyImgixParameters } from 'utils/imgix'
import { CellProps, ImageValue } from './TableTypes'
import AppContext from '../../contexts/AppContext'
import { AppContextTypes } from '../../interfaces'

class ImageCell extends PureComponent<CellProps> {
  static contextType = AppContext

  render() {
    const { cell } = this.props
    const { getImageUploadsBaseURL } = this.context as AppContextTypes

    const imageValue = cell.value as ImageValue
    const imageRatio = cell.binding?.format?.imageRatio

    if (!imageValue || !imageRatio) {
      return null
    }

    const size = ImageRatioStyle[imageRatio]

    const imageURL = applyImgixParameters(
      `${getImageUploadsBaseURL()}/${imageValue.url}`,
      size
    )

    const imageStyle: StyleProp<ImageStyle>[] = [
      styles.image,
      imageRatio === ImageRatios.circle && styles.imageCircle,
      size,
    ]

    return (
      <Image source={{ uri: imageURL }} style={imageStyle} resizeMode="cover" />
    )
  }
}

const styles = StyleSheet.create({
  container: {
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
  },
  image: {
    borderRadius: 4,
  },
  imageCircle: {
    borderRadius: 999,
  },
})

export default ImageCell
